import type { ClientAuthDTO } from '@brainkey/shared';
import { hasTierAccess, MIN_TIER_FOR_BOOKINGS, MIN_TIER_FOR_BRAIN_SWOT } from '@brainkey/shared';

export { MIN_TIER_FOR_BOOKINGS, MIN_TIER_FOR_BRAIN_SWOT };

/**
 * Tier-based feature gating (P21-T06) — a thin client-portal wrapper around
 * the shared `hasTierAccess`/`MIN_TIER_FOR_*` constants so the UI gate can
 * never drift from the API's own defense-in-depth re-check. `client` may be
 * `null` while auth is still resolving; treated as not-yet-entitled.
 */
export function clientHasTierAccess(client: ClientAuthDTO | null, requiredTier: number): boolean {
  return hasTierAccess(client?.activeTier ?? null, requiredTier);
}
